import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../../../shared/auth/user-context";
import { REDUCTION_PATH } from "../../../shared/routing/paths/reduction";

const LAST_ACCOUNT_STORAGE_KEY = "reduction:last-account-id";

/**
 * Mounted once at the reduction route root. The previous account is persisted in `sessionStorage`, not
 * a ref, on purpose: app-shell remounts the React tree on an account switch (and may do a full page
 * reload), which would make the new account look like the first one seen. The first account observed
 * in the session is not a switch, so no redirect happens then.
 */
export const useRedirectOnAccountSwitch = (): void => {
  const customerId = useContext(UserContext).user?.customerId ?? null;
  const navigate = useNavigate();

  useEffect(() => {
    if (customerId === null) {
      return;
    }

    const previousCustomerId = sessionStorage.getItem(LAST_ACCOUNT_STORAGE_KEY);
    sessionStorage.setItem(LAST_ACCOUNT_STORAGE_KEY, customerId);

    if (previousCustomerId !== null && previousCustomerId !== customerId) {
      navigate(REDUCTION_PATH, { replace: true });
    }
  }, [customerId, navigate]);
};
